import { ReactNode } from "react";

import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Card from "ds/components/Card";
import IconEmphasized from "ds/components/IconEmphasized";
import { IconEmphasizedColor } from "ds/components/IconEmphasized/types";
import Tooltip from "ds/components/Tooltip";
import Typography from "ds/components/Typography";
import { IconComponent } from "types/Icon";

type RequirementCardProps = {
  icon: IconComponent;
  iconColor: IconEmphasizedColor;
  title: string;
  description: ReactNode;
  actionLabel: string;
  onAction: () => void;
  isActionDisabled?: boolean;
  actionTooltip?: string;
};

const RequirementCard = ({
  icon,
  iconColor,
  title,
  description,
  actionLabel,
  onAction,
  isActionDisabled,
  actionTooltip,
}: RequirementCardProps) => (
  <Card fullWidth>
    <Box gap="medium" fullWidth>
      <IconEmphasized icon={icon} color={iconColor} />
      <Box align="center" gap="medium" grow="1" zeroMinWidth>
        <Box direction="column" gap="small" grow="1" zeroMinWidth>
          <Typography variant="p-t8" tag="p">
            {title}
          </Typography>
          <Typography variant="p-body4" tag="p" color="secondary">
            {description}
          </Typography>
        </Box>
        <Tooltip
          active={!!actionTooltip}
          on={(props) => (
            <Button
              {...props}
              variant="secondary"
              size="small"
              onPress={onAction}
              disabled={isActionDisabled}
            >
              {actionLabel}
            </Button>
          )}
        >
          {actionTooltip}
        </Tooltip>
      </Box>
    </Box>
  </Card>
);

export default RequirementCard;
